/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */

/**
 * Defines which participants must accept a given legal document.
 *
 * Card scopes are per card programme because each programme has its own
 * agreement: Highnote's Card Holder Agreement, and for Stripe's US platform
 * (Celtic Bank, also covering Canada) the Stripe E-Sign Disclosure and the
 * Authorized User Terms. Stripe's other platforms need no cardholder terms.
 */
export type LegalDocumentRequirementScope =
  (typeof LegalDocumentRequirementScope)[keyof typeof LegalDocumentRequirementScope];

export const LegalDocumentRequirementScope = {
  ALL_USERS: "ALL_USERS",
  HIGHNOTE_CARDHOLDERS: "HIGHNOTE_CARDHOLDERS",
  US_STRIPE_CARDHOLDERS: "US_STRIPE_CARDHOLDERS",
} as const;
